<div fxLayoutAlign="end" fxLayoutGap="16px" class="m-b-sm">
    @if (entityInstanceInfo().canApprove) {
        <button mat-button color="accent" [disabled]="disabled()" (click)="approveRejectDocument(true)">
            <mat-icon class="material-symbols-outlined">check</mat-icon>
            {{ entityInstanceInfo().approveLabel }}
        </button>
        <button mat-button color="warn" [disabled]="disabled()" (click)="approveRejectDocument(false)">
            <mat-icon class="material-symbols-outlined">cancel</mat-icon>
            {{ entityInstanceInfo().rejectLabel }}
        </button>
    }
    @if (entityInstanceInfo().canApprove && entityInstanceInfo().canComment) {
        <button mat-button color="primary" [disabled]="disabled()" (click)="commentDocument()">
            <mat-icon class="material-symbols-outlined">comment</mat-icon>
            {{ entityInstanceInfo().commentLabel }}
        </button>
    }
    @if (entityInstanceInfo().canCancel) {
        <button mat-button [disabled]="disabled()" (click)="cancelApproval()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
            {{ "awaitingApproval.cancelApproval" | translate }}
        </button>
    }
</div>
@if (entityInstanceInfo().canApprove && entityInstanceInfo().canComment) {
    <app-froala [label]="'awaitingApproval.commentTitle' | translate" [(content)]="approvalComment" />
}
